/** @jsxImportSource @emotion/react */
import tw from "twin.macro";
import { css } from "@emotion/css";
import {
  format,
  formatISO,
  getMonth,
  isEqual,
  startOfDay,
  startOfToday,
} from "date-fns";
import React, { FC, memo } from "react";
import { NoteList } from "../view/NoteList";
import { isInDayBacklog, putInDayBacklog } from "../state/data/utils";
import { Column, columnToId, DayColumn } from "./Calendar";
import CalendarSVG from "../svgs/CalendarIcon";
import jan from "./media/months/01_January.png";
import feb from "./media/months/02_February.png";
import mar from "./media/months/03_March.png";
import apr from "./media/months/04_April.png";
import may from "./media/months/05_May.png";
import june from "./media/months/06_June.png";
import jul from "./media/months/07_July.png";
import aug from "./media/months/08_August.png";
import sep from "./media/months/09_September.png";
import oct from "./media/months/10_October.png";
import nov from "./media/months/11_November.png";
import dec from "./media/months/12_December.png";

const monthIllus = [
  jan,
  feb,
  mar,
  apr,
  may,
  june,
  jul,
  aug,
  sep,
  oct,
  nov,
  dec,
];

export const DayColumnHeader = memo(({ d }: { d: Date }) => {
  const isToday = isEqual(startOfToday(), startOfDay(d));
  return (
    <div
      className={css`
        height: 100%;
        display: flex;
        flex-direction: column;
      `}
    >
      <div
        className={css`
          border-bottom: 1px solid rgba(0, 0, 0, 0.202);
          height: 70px;
          display: grid;
          place-items: center;
          position: relative;
        `}
      >
        {isToday && (
          <div
            className={css`
              position: absolute;
              height: 100%;
              width: 40px;
              background-color: #303f9f;
            `}
          ></div>
        )}
        <span
          className={css`
            font-size: 12px;
            text-transform: uppercase;
            color: ${isToday ? "white" : "initial"};
            z-index: 12;
          `}
        >
          {format(d, "E")}
        </span>
        <span
          className={css`
            font-size: 26px;
            letter-spacing: -2.6px;
            text-indent: -2.6px;
            margin-top: -20px;
            color: ${isToday ? "white" : "initial"};
            z-index: 12;
          `}
        >
          {format(d, "d")}
        </span>
      </div>
      <div
        tw="overflow-y-auto overflow-x-hidden h-full"
        className={css`
          border-bottom: 1px solid rgba(0, 0, 0, 0.202);
        `}
      >
        <NoteList
          selector={isInDayBacklog(d)}
          effector={putInDayBacklog(d)}
          id={"day" + formatISO(d)}
        />
      </div>
    </div>
  );
});
